export function NateraIcon({
  className,
  size = '24',
}: {
  className?: string
  size?: '24' | '18' | '16'
}) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8090_7400)">
        <circle
          cx="12"
          cy="12"
          r="2"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.37922 9.54857C8.60986 9.54857 9.76114 9.91663 10.7482 10.5555C10.2733 9.55884 10.0035 8.42711 10.0035 7.2258C10.0035 5.19862 10.7686 3.36776 11.9999 2.05553C10.8074 0.784243 9.17753 0 7.37922 0C3.72439 0 0.761719 3.23528 0.761719 7.2258C0.761719 9.05635 1.38633 10.7267 2.41401 12.0002C3.62642 10.4978 5.40069 9.54857 7.37922 9.54857Z"
          fill="#008BCE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2518 10.5555C14.2389 9.91663 15.3904 9.54857 16.6211 9.54857C18.5992 9.54857 20.3739 10.4975 21.5863 12.0002C22.6139 10.7267 23.2389 9.05635 23.2389 7.2258C23.2389 3.23496 20.2759 0 16.6211 0C14.8228 0 13.1929 0.784243 12 2.05553C13.2316 3.36776 13.9968 5.19862 13.9968 7.2258C13.9968 8.42711 13.7269 9.55884 13.2518 10.5555Z"
          fill="#8BC400"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7447 10.5519C11.2003 10.8468 11.62 11.1992 11.9965 11.6005C12.373 11.1992 12.793 10.8468 13.2482 10.5519C13.7233 9.55526 13.9932 8.42354 13.9932 7.22223C13.9932 5.19503 13.2278 3.36417 11.9965 2.05194C10.7652 3.36417 10 5.19503 10 7.22223C10 8.42354 10.2696 9.55526 10.7447 10.5519Z"
          fill="#005B7E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7484 13.4443C9.76149 14.0832 8.60986 14.4512 7.37954 14.4512C5.40101 14.4512 3.62674 13.5023 2.41401 11.9996C1.38633 13.2731 0.761719 14.9435 0.761719 16.774C0.761719 20.7649 3.7247 24.0001 7.37954 24.0001C9.17781 24.0001 10.8074 23.2156 12.0003 21.944C10.769 20.6324 10.0038 18.8012 10.0038 16.774C10.0038 15.5727 10.2733 14.441 10.7484 13.4443Z"
          fill="#8BC400"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.37912 14.4513C8.60979 14.4513 9.761 14.0832 10.748 13.4444C10.9971 12.9222 11.3026 12.4374 11.6557 11.9997C11.3026 11.5619 10.9971 11.0775 10.748 10.5553C9.761 9.91606 8.60979 9.54828 7.37912 9.54828C5.40059 9.54828 3.62632 10.4972 2.41391 11.9997C3.62632 13.502 5.40059 14.4513 7.37912 14.4513Z"
          fill="#005B7E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.6211 14.4517C15.3904 14.4517 14.2389 14.0835 13.2518 13.4447C13.7269 14.4413 13.9968 15.5731 13.9968 16.7744C13.9968 18.8016 13.2314 20.6328 12 21.9443C13.1929 23.216 14.8228 24.0002 16.6211 24.0002C20.2759 24.0002 23.2386 20.7652 23.2386 16.7744C23.2386 14.9439 22.6139 13.2736 21.5863 12C20.3735 13.5024 18.5992 14.4517 16.6211 14.4517Z"
          fill="#008BCE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.6223 9.54828C15.3916 9.54828 14.24 9.91641 13.253 10.5553C13.0042 11.0775 12.6988 11.5622 12.3457 11.9999C12.6988 12.4377 13.0042 12.9222 13.253 13.4443C14.24 14.0836 15.3916 14.4513 16.6223 14.4513C18.6004 14.4513 20.3747 13.5024 21.5874 11.9999C20.3747 10.4976 18.6004 9.54828 16.6223 9.54828Z"
          fill="#005B7E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2521 13.4442C12.7969 13.1496 12.3768 12.7969 12.0004 12.3957C11.6239 12.7969 11.2042 13.1496 10.7486 13.4442C10.2738 14.4409 10.0039 15.5726 10.0039 16.774C10.0039 18.8011 10.7691 20.6323 12.0004 21.9439C13.232 20.6323 13.9971 18.8011 13.9971 16.774C13.9971 15.5726 13.7272 14.4409 13.2521 13.4442Z"
          fill="#005B7E"
        />
      </g>
      <defs>
        <clipPath id="clip0_8090_7400">
          <rect
            width="24"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
